import { render, staticRenderFns } from "./MaterialKanban.vue?vue&type=template&id=4e57edde&scoped=true"
import script from "./MaterialKanban.vue?vue&type=script&lang=js"
export * from "./MaterialKanban.vue?vue&type=script&lang=js"
import style0 from "./MaterialKanban.vue?vue&type=style&index=0&id=4e57edde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e57edde",
  null
  
)

export default component.exports